var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('w-row',[_c('w-col',{attrs:{"xs":"12"}},[_c('app-select-journal',{attrs:{"no-journal-option":"","no-journal-option-label":_vm.$ct('common.no-journal'),"value":_vm.val,"label":_vm.label,"fancy":""},on:{"input":function($event){return _vm.onInput($event)}}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }